import Error from '../model/Error';
import axios from 'axios';

export default class ApplicationDogRepository {
    static update(applicationDog) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/application-dog/${applicationDog.id}`, applicationDog.serialize())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
